import React from 'react';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  TextField,
  Stack,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  CircularProgress,
} from '@mui/material';
import type { SelectChangeEvent } from '@mui/material';
import type { AddUserModalProps } from './types';
import { USER_ROLE_OPTIONS } from '@/config/constant';
import type { UserRole } from '@/config/constant';

export const AddUserModal: React.FC<AddUserModalProps> = ({
  open,
  loading,
  newUser,
  onClose,
  onEmailChange,
  onRoleChange,
  onSubmit,
}) => {
  const handleRoleChange = (event: SelectChangeEvent<UserRole>) => {
    onRoleChange(event.target.value as UserRole);
  };

  return (
    <Dialog open={open} onClose={onClose} maxWidth="sm" fullWidth>
      <DialogTitle>Add New User</DialogTitle>
      <DialogContent>
        <Stack spacing={2} sx={{ mt: 2 }}>
          <TextField
            label="Email"
            type="email"
            value={newUser.email}
            onChange={(e) => onEmailChange(e.target.value)}
            fullWidth
            required
            disabled={loading}
            placeholder="user@example.com"
            helperText="User will receive a temporary password via email"
          />
          <FormControl fullWidth required disabled={loading}>
            <InputLabel id="user-role-label">Role</InputLabel>
            <Select<UserRole>
              labelId="user-role-label"
              value={newUser.role}
              onChange={handleRoleChange}
              label="Role"
            >
              {USER_ROLE_OPTIONS.map((option) => (
                <MenuItem key={option.value} value={option.value}>
                  {option.label}
                </MenuItem>
              ))}
            </Select>
          </FormControl>
        </Stack>
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose} disabled={loading}>
          Cancel
        </Button>
        <Button variant="contained" onClick={onSubmit} disabled={loading || !newUser.email}>
          {loading ? <CircularProgress size={24} /> : 'Create User'}
        </Button>
      </DialogActions>
    </Dialog>
  );
};
